import { SECONDARY_ITEMS, visibleNavItems } from './nav-items';
import type { NavItemId } from './nav-items';
import type { User } from '../../types/user';

interface SecondaryNavPanelProps {
  onNavigate: (id: NavItemId) => void;
  /** Whose hub it is — a screen they may not reach is not listed. */
  user: User;
}

/**
 * The "עוד" hub. The sidebar has room for every destination; the phone's tab
 * bar does not, so whatever is not a tab is listed here — nothing in the
 * application is reachable on a desktop alone.
 */
export function SecondaryNavPanel({ onNavigate, user }: SecondaryNavPanelProps) {
  const items = visibleNavItems(user, SECONDARY_ITEMS);
  if (items.length === 0) return null;

  return (
    <section className="bg-panel border border-line rounded-2xl p-4">
      <h2 className="text-sm font-semibold mb-3">מסכים נוספים</h2>
      <div className="grid grid-cols-2 gap-2">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onNavigate(item.id)}
              className="h-14 rounded-xl border border-line bg-canvas hover:border-brand-300 hover:bg-brand-50 transition-colors px-3 flex items-center gap-3 text-right"
            >
              <Icon size={18} className="text-brand-500 shrink-0" aria-hidden />
              <span className="min-w-0">
                <span className="block text-sm font-medium truncate">{item.label}</span>
                <span className="block text-xs text-ink/50 truncate">{item.title}</span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
